import React, { useState } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import useEditorStore from '../../store/editorStore';
import { frameStyles } from '../../config/constants';
import './QRCodeBlock.css';

function QRCodeBlock({ block }) {
  const { updateBlock } = useEditorStore();
  const [isEditing, setIsEditing] = useState(false);
  const [tempValue, setTempValue] = useState(block.styles.value || 'https://www.pea.co.th');

  const handleDoubleClick = (e) => {
    e.stopPropagation();
    setIsEditing(true);
  };

  const handleSave = () => {
    updateBlock(block.id, {
      styles: {
        ...block.styles,
        value: tempValue
      }
    });
    setIsEditing(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSave();
    } else if (e.key === 'Escape') {
      setTempValue(block.styles.value);
      setIsEditing(false);
    }
  };

  // Get selected frame style
  const selectedFrame = frameStyles.find(s => s.id === block.styles.frameStyle) || frameStyles[0];
  const frameStyle = selectedFrame.style || {};

  const wrapperStyle = {
    width: '100%',
    height: '100%',
    boxSizing: 'border-box',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    ...frameStyle
  };

  return (
    <div className="qrcode-block" onDoubleClick={handleDoubleClick} style={wrapperStyle}>
      {isEditing ? (
        <div className="qrcode-editor" style={{width: '100%', height: '100%'}}>
          <input
            autoFocus
            type="text"
            value={tempValue}
            onChange={(e) => setTempValue(e.target.value)}
            onBlur={handleSave}
            onKeyDown={handleKeyDown}
            placeholder="Enter URL..."
            style={{width: '100%', height: '100%', padding: '8px'}}
          />
        </div>
      ) : (
        <div className="qrcode-container" style={{
            width: '100%', 
            height: '100%', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            transform: `scale(${(block.styles.zoom || 100) / 100})`,
        }}>
          <QRCodeCanvas
            value={block.styles.value || 'https://www.pea.co.th'}
            size={Math.min(block.width, block.height) * 0.9} // Scale to fit
            bgColor={block.styles.backgroundColor || '#FFFFFF'}
            fgColor={block.styles.color || '#000000'}
            level={block.styles.level || 'M'}
            includeMargin={block.styles.includeMargin || false}
          />
        </div>
      )}
    </div>
  );
}

export default QRCodeBlock;
